import type { StoreProductVariant } from "@/types/store"

const TURKISH_CHAR_MAP: Record<string, string> = {
  ç: "c",
  Ç: "c",
  ğ: "g",
  Ğ: "g",
  ı: "i",
  I: "i",
  İ: "i",
  ö: "o",
  Ö: "o",
  ş: "s",
  Ş: "s",
  ü: "u",
  Ü: "u",
}

export const normalizeProductVariantParam = (value: string) =>
  value
    .replace(/[çÇğĞıIİöÖşŞüÜ]/g, (char) => TURKISH_CHAR_MAP[char] ?? char)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-")

export const getProductVariantParam = (title?: string | null) =>
  title ? normalizeProductVariantParam(title) : ""

export function canQuickAddVariant(
  variant?: StoreProductVariant | null
): boolean {
  if (!variant?.id) return false

  const hasRequiredFormQuestions =
    Array.isArray(variant.form_questions) &&
    variant.form_questions.length > 0
  const isInfiniteStock = variant.stock_type === "infinite"
  const isInStock =
    isInfiniteStock ||
    Boolean(variant.allow_backorder) ||
    (variant.inventory_quantity ?? 0) > 0
  const hasPrice = Boolean(variant.sales_price ?? 0)

  return !hasRequiredFormQuestions && isInStock && hasPrice
}
